// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\pages\doctors\DoctorsPage\ArchivedModal.js

import React, { useEffect, useState } from 'react';
import { Modal, Table, Button, Spin, Alert, Tooltip, Tag } from 'antd';
import { toast } from 'react-toastify';
import { UndoOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getArchivedPersons, restorePerson } from '../../../redux/slices/persons/personsThunk';

const ArchivedModal = ({ visible, onClose, onRestoreSuccess }) => {
  const dispatch = useDispatch();
  const { archivedPersons, loading, error } = useSelector((state) => state.persons);
  const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 5 });

  useEffect(() => {
    if (visible) {
      dispatch(getArchivedPersons({ 
        type: 1, // Type 1 pour les médecins
        page: pagination.currentPage, 
        limit: pagination.pageSize 
      }));
    }
  }, [visible, pagination, dispatch]);

  const handleRestore = async (id) => {
    const resultAction = await dispatch(restorePerson(id));
    if (restorePerson.fulfilled.match(resultAction)) {
      toast.success('Médecin restauré avec succès !');
      onRestoreSuccess(); // Rafraîchit la liste principale des médecins
    } else {
      toast.error(resultAction.payload || 'La restauration a échoué.');
    }
  };

  const columns = [
    { title: 'Nom', dataIndex: 'lastname' },
    { title: 'Prénom', dataIndex: 'firstname' },
    {
      title: "Motif d'archivage",
      dataIndex: 'archiveReason',
      key: 'archiveReason',
      render: (reason) => reason ? (
        <Tag color="volcano" style={{ fontWeight: 500 }}>
          {reason}
        </Tag>
      ) : (
        <span style={{ color: '#8c8c8c', fontStyle: 'italic' }}>Non renseigné</span>
      )
    },
    {
      title: 'Archivé le',
      dataIndex: 'deletedAt',
      render: (date) => new Date(date).toLocaleDateString('fr-FR'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (record) => (
        <Tooltip title="Restaurer">
          <Button
            type="primary"
            icon={<UndoOutlined />}
            onClick={() => handleRestore(record.id)}
            loading={loading && record.id === (/* id en cours de restauration */ null)} // Logique de chargement par bouton si besoin
          />
        </Tooltip>
      ),
    },
  ];

  const handleTableChange = (page) => {
    setPagination({ currentPage: page.current, pageSize: page.pageSize });
  };

  return (
    <Modal
      title="Médecins Archivés"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      destroyOnClose
    >
      {loading && !archivedPersons.data.length && <Spin />}
      {error && <Alert message={error} type="error" style={{ marginBottom: 16 }} />}
      <Table
        columns={columns}
        dataSource={archivedPersons?.data}
        rowKey="id"
        loading={loading}
        pagination={{ 
          current: pagination.currentPage, 
          pageSize: pagination.pageSize, 
          total: archivedPersons?.total 
        }}
        onChange={handleTableChange}
      />
    </Modal>
  );
};

export default ArchivedModal;